export const SelectedAddOnsKey = 'v2_selected_add_ons';
